export const januaryAbbreviatedLowercase = "aZKBxc";
export default {januaryAbbreviatedLowercase};